/**
 * PresetThumb — procedural, deterministic cover for a style preset.
 *
 * Uses the same ModelCover engine but maps preset.category → cover.category so
 * the geometry/palette feels coherent with what the preset actually does.
 * Falls back to a vibrant gradient if anything goes wrong.
 */
import ModelCover from './ModelCover';

// preset.category (from backend) → ModelCover category (visual vibe)
const PRESET_CAT_MAP = {
  Photo:        'photorealistic',
  Illustration: 'anime',
  'Sci-Fi':     'commercial',
  Retro:        'animation',
  Painting:     'artistic',
  Drawing:      'design',
  Fantasy:      'cinematic',
  Art:          'artistic',
  Design:       'design',
  '3D':         '3d',
  Film:         'cinematic',
  Animation:    'animation',
  Effect:       'commercial',
  Nature:       'photorealistic',
};

const VIDEO_CATEGORIES = new Set(['Film', 'Animation', 'Effect', 'Nature']);

export default function PresetThumb({ preset, selected = false }) {
  // Adapt preset shape → model shape that ModelCover expects
  const pseudoModel = {
    id:       `preset-${preset.id}`,
    name:     preset.name,
    category: PRESET_CAT_MAP[preset.category] || 'general',
    kind:     VIDEO_CATEGORIES.has(preset.category) ? 'video' : 'image',
    tier:     'standard',
  };
  return (
    <div
      className="relative w-full h-full overflow-hidden d2-preset-thumb group"
      data-testid={`preset-thumb-${preset.id}`}
    >
      <ModelCover model={pseudoModel} size={220} />
      {/* Bottom gradient for legibility of the preset name */}
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/85 via-black/30 to-transparent pointer-events-none" style={{ zIndex: 3 }} />
      {selected && (
        <div className="absolute inset-0 ring-2 ring-[#FF6B4A] ring-inset rounded-lg pointer-events-none" style={{ zIndex: 4 }} />
      )}
    </div>
  );
}
